// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 3: YESU KRISTO
// ============================================================================
// Viwango 27-39 (viwango 13, maswali 39)

export const chapter3Translations = {
  name: 'Yesu Kristo',
  description: 'Neno likawa mwili... Kumjua Kristo ni uzima wa milele',
  
  spiritualWisdom: {
    principle: 'Kumjua Yesu Kristo ni uzima wa milele',
    scripture: 'Na huu ndio uzima wa milele: wapate kukujua wewe, Mungu wa kweli pekee, na yule uliyemtuma, Yesu Kristo (Yohana 17:3)',
    application: 'Kila kipengele cha maisha ya Yesu huufunua Mungu na kulisha roho yetu kwa ajili ya milele'
  },
  
  levels: {
    27: {
      name: 'Tangazo',
      challenge: 'Malaika Gabrieli alitumwa na Mungu kwenda mji wa Galilaya...',
      easy: {
        question: 'Ni malaika gani aliyemtangazia Mariamu kwamba atamzaa Yesu?',
        options: ['Mikaeli', 'Gabrieli', 'Rafaeli', 'Urieli'],
        hint: 'Malaika mjumbe wa Mungu',
        funFact: '👼 Gabrieli maana yake ni Nguvu ya Mungu - malaika wa matangazo makuu!'
      },
      medium: {
        question: 'Majibu ya kwanza ya Mariamu kuhusu tangazo hili yalikuwa nini?',
        options: [
          'Furaha mara moja',
          'Kutokuamini kabisa',
          'Kuchanganyikiwa na swali Hili litatokea vipi?',
          'Hofu'
        ],
        hint: 'Swali la kimantiki na halali',
        funFact: '🤔 Mariamu anauliza swali la mantiki lakini anaweka moyo wazi kwa Mungu!'
      },
      hard: {
        question: 'Kujisalimisha kwa Mariamu kwa mapenzi ya Mungu kunatufundisha nini?',
        options: [
          'Kukosa ushirikiano mbele ya majaribu',
          'Imani inayoamini hata bila kuelewa yote',
          'Utii kipofu',
          'Kukubali tu'
        ],
        hint: 'Ni kuhusu kumwamini Mungu hata katika yasiyojulikana',
        funFact: '🙏 Na iwe kwangu kama ulivyosema - mfano wa imani ya kuamini!'
      }
    },
    
    28: {
      name: 'Kuzaliwa',
      challenge: 'Akamzaa mwanawe wa kwanza, akamfunga nguo, akamweka katika hori...',
      easy: {
        question: 'Yesu alizaliwa katika mji gani?',
        options: ['Nazareti', 'Yerusalemu', 'Bethlehemu', 'Kapernaumu'],
        hint: 'Mji wa Daudi',
        funFact: '🏘️ Bethlehemu maana yake ni Nyumba ya Mkate - Yesu, mkate wa uzima!'
      },
      medium: {
        question: 'Ni nani waliopokea habari ya kuzaliwa kwanza?',
        options: [
          'Wanaume wenye hekima',
          'Wachungaji mashambani',
          'Makuhani wa Hekalu',
          'Familia ya Mariamu'
        ],
        hint: 'Watu wa kawaida wanaolinda makundi yao',
        funFact: '🐑 Mungu anatangaza kwanza kwa wachungaji wanyenyekevu - Injili kwa wote!'
      },
      hard: {
        question: 'Yesu kuzaliwa katika hori inamaanisha nini?',
        options: [
          'Umaskini wa wazazi wake',
          'Unyenyekevu wa Mungu anayetuinamia',
          'Ukosefu wa nafasi',
          'Urahisi wa vijijini'
        ],
        hint: 'Ni kuhusu mwili wa kimungu katika unyenyekevu',
        funFact: '👶 Muumba wa ulimwengu anazaliwa katika banda - upendo usio na kikomo!'
      }
    },

    29: {
      name: 'Wanaume Wenye Hekima kutoka Mashariki',
      challenge: 'Wanaume wenye hekima kutoka mashariki walifika Yerusalemu na kuuliza...',
      easy: {
        question: 'Ni nini kiliwaongoza wanaume wenye hekima kwa Yesu?',
        options: ['Malaika', 'Nyota', 'Maono', 'Ramani'],
        hint: 'Nyota angani',
        funFact: '⭐ Nyota inawakilisha kwamba Yesu ni nuru ya mataifa!'
      },
      medium: {
        question: 'Wanaume wenye hekima walitoa zawadi gani?',
        options: [
          'Chakula',
          'Dhahabu, ubani na manemane',
          'Mavazi ya thamani',
          'Vifaa vya kuchezea'
        ],
        hint: 'Zawadi tatu za ishara na thamani',
        funFact: '🎁 Dhahabu (ufalme), ubani (uungu), manemane (dhabihu) - ujumbe wote wa Yesu!'
      },
      hard: {
        question: 'Wanaume hawa wenye hekima wasio Wayahudi wanawakilisha nini katika mpango wa Mungu?',
        options: [
          'Ubora wa dini nyingine',
          'Ulimwengu wa wokovu uliotolewa kwa mataifa yote',
          'Utajiri wa kimwili',
          'Sayansi ya kale'
        ],
        hint: 'Ni kuhusu kufungua wokovu kwa mataifa yote',
        funFact: '🌍 Wanaume wenye hekima wanaashiria Injili itakayofikia ulimwengu wote!'
      }
    },

    30: {
      name: 'Ubatizo wa Yesu',
      challenge: 'Mara Yesu alipobatizwa, alitoka majini...',
      easy: {
        question: 'Ni nani aliyembatiza Yesu?',
        options: ['Petro', 'Yohana Mbatizaji', 'Andrea', 'Yakobo'],
        hint: 'Mtangulizi wa Yesu',
        funFact: '🌊 Yohana Mbatizaji alijihisi hana sifa ya kufungua viatu vya Yesu!'
      },
      medium: {
        question: 'Ni nini kilishuka juu ya Yesu wakati wa ubatizo wake?',
        options: [
          'Nuru',
          'Njiwa (Roho Mtakatifu)',
          'Malaika',
          'Sauti tu'
        ],
        hint: 'Ndege ishara ya amani',
        funFact: '🕊️ Njiwa inafunua upako wa kimungu kuanza huduma!'
      },
      hard: {
        question: 'Kwa nini Yesu, bila dhambi, alibatizwa?',
        options: [
          'Kutoa mfano',
          'Kutimiza haki yote na kujitambulisha nasi',
          'Kwa sababu ya wajibu wa kidini',
          'Kupokea msamaha'
        ],
        hint: 'Ni kuhusu umoja na wanadamu wenye dhambi',
        funFact: '❤️ Yesu anajitambulisha kabisa nasi ili atuokoe vizuri zaidi!'
      }
    },

    31: {
      name: 'Majaribu Jangwani',
      challenge: 'Yesu aliongozwa na Roho jangwani ajaribiwe na shetani...',
      easy: {
        question: 'Yesu alifunga muda gani jangwani?',
        options: ['Siku 30', 'Siku 40', 'Siku 50', 'Siku 60'],
        hint: 'Nambari ya Biblia ya majaribu',
        funFact: '🏜️ Kama Mose na Eliya, siku 40 za maandalizi makali ya kiroho!'
      },
      medium: {
        question: 'Yesu alikataa kila jaribu vipi?',
        options: [
          'Kwa nguvu zake mwenyewe',
          'Kwa kusoma Maandiko',
          'Kwa kumpuuza shetani',
          'Kwa kuomba tu'
        ],
        hint: 'Silaha ya kiroho bora zaidi',
        funFact: '📖 Imeandikwa... - Neno la Mungu, upanga wa Roho!'
      },
      hard: {
        question: 'Majaribu ya Yesu yanatufundisha nini kuhusu mapambano yetu?',
        options: [
          'Majaribu ni dhambi',
          'Jaribu linaweza kushindwa kwa Neno na imani',
          'Lazima tukimbie kutoka kila jangwa',
          'Ni Yesu pekee anayeweza kushindana'
        ],
        hint: 'Ni kuhusu mkakati wetu dhidi ya majaribu',
        funFact: '⚔️ Yesu anatuonyesha jinsi ya kushinda: Neno la Mungu + imani ya vitendo!'
      }
    },

    32: {
      name: 'Wanafunzi wa Kwanza',
      challenge: 'Yesu aliwaambia: Nifuateni, nitawafanya wavuvi wa watu...',
      easy: {
        question: 'Petro na Andrea walikuwa na kazi gani?',
        options: ['Wachungaji', 'Wavuvi', 'Maseremala', 'Watoza ushuru'],
        hint: 'Kazi kwenye ziwa la Galilaya',
        funFact: '🎣 Yesu anageuza wavuvi wa samaki kuwa wavuvi wa roho!'
      },
      medium: {
        question: 'Wanafunzi wa kwanza waliitikaje kwa wito?',
        options: [
          'Walikawia muda mrefu',
          'Waliomba ushahidi',
          'Waliacha kila kitu na kumfuata mara moja',
          'Walishauriana'
        ],
        hint: 'Majibu ya papo hapo na kamili',
        funFact: '🚶 Mamlaka ya Yesu ilikuwa dhahiri sana hivi wakatii mara moja!'
      },
      hard: {
        question: 'Kumfuata Yesu katika wakati wetu maana yake nini?',
        options: [
          'Kuacha kazi',
          'Kuishi kulingana na mafundisho yake na mapenzi yake',
          'Kujiunga na jamii iliyotengwa',
          'Kuhubiri tu'
        ],
        hint: 'Ni kuhusu mabadiliko ya maisha na vipaumbele',
        funFact: '✨ Kumfuata Yesu hubadilisha mioyo yetu, uchaguzi wetu, hatima yetu!'
      }
    },

    33: {
      name: 'Hotuba ya Mlimani',
      challenge: 'Heri maskini wa roho, kwa maana ufalme wa mbinguni ni wao...',
      easy: {
        question: 'Heri ya kwanza katika Hotuba ya Mlimani ni ipi?',
        options: [
          'Heri wenye moyo safi',
          'Heri maskini wa roho',
          'Heri wapole',
          'Heri wapatanishi'
        ],
        hint: 'Inahusu unyenyekevu wa kiroho',
        funFact: '😊 Maskini wa roho wanajua mahitaji yao kwa Mungu - lango la Ufalme!'
      },
      medium: {
        question: 'Yesu alisema nini kuhusu wapatanishi?',
        options: [
          'Watakuwa na bahati',
          'Wataitwa wana wa Mungu',
          'Watapendwa',
          'Watakuwa na nguvu'
        ],
        hint: 'Utambulisho maalum wa kimungu',
        funFact: '👑 Wapatanishi wanafanana na Mungu - ushuhuda hai wa asili Yake!'
      },
      hard: {
        question: 'Heri zinageuza vipi maadili ya dunia?',
        options: [
          'Kwa kulaumu utajiri',
          'Kwa kutenga waumini',
          'Kwa kutangaza heri kwa wale dunia inavyowadharau',
          'Kwa kubatilisha sheria'
        ],
        hint: 'Ni kuhusu maadili ya kimungu kinyume na ya kidunia',
        funFact: '🔄 Heri zinabadilisha mtazamo wetu wa furaha na mafanikio!'
      }
    },

    34: {
      name: 'Mifano ya Ufalme',
      challenge: 'Aliwafundisha mambo mengi kwa mifano...',
      easy: {
        question: 'Katika mfano wa mpanzi, mbegu inawakilisha nini?',
        options: [
          'Pesa',
          'Neno la Mungu',
          'Matendo mema',
          'Upendo'
        ],
        hint: 'Kile Yesu anachohubiri na kufundisha',
        funFact: '🌱 Neno la Mungu linachipua na kukua mioyoni mwetu!'
      },
      medium: {
        question: 'Katika mfano wa punje ya haradali, mbegu hii ndogo inasimboliza nini?',
        options: [
          'Udhaifu wa kibinadamu',
          'Ufalme unaoanza mdogo lakini unakuwa mkubwa',
          'Umuhimu wa mambo madogo',
          'Asili'
        ],
        hint: 'Kitu kinachokua kwa njia ya ajabu',
        funFact: '🌳 Kutoka mbegu ndogo zaidi inazaliwa mti mkubwa - nguvu ya Ufalme!'
      },
      hard: {
        question: 'Kwa nini Yesu alifundisha kwa mifano?',
        options: [
          'Kufanya ujumbe Wake kuwa mgumu',
          'Kufunua ukweli wa kiroho kupitia picha zinazoeleweka',
          'Kwa kukosa muda',
          'Kupima akili'
        ],
        hint: 'Ni kuhusu kufanya siri za Ufalme zipatikane',
        funFact: '💡 Mifano inafunua kwa mioyo iliyo wazi na kuficha kutoka kwa iliyofungwa!'
      }
    },

    35: {
      name: 'Miujiza ya Yesu',
      challenge: 'Alituliza dhoruba na kusema kwa bahari: Tulia! Nyamaza!...',
      easy: {
        question: 'Yesu aliwalisisha watu 5000 kwa mikate mingapi?',
        options: ['Mikate 3', 'Mikate 5', 'Mikate 7', 'Mikate 12'],
        hint: 'Idadi sawa na samaki',
        funFact: '🍞 Mikate 5 na samaki 2 yanakuwa karamu - ukarimu wa kimungu!'
      },
      medium: {
        question: 'Wanafunzi walisema nini Yesu alipotulia dhoruba?',
        options: [
          'Ni mchawi',
          'Huyu ni nani hata upepo na bahari vinamtii?',
          'Ni kawaida',
          'Tunapaswa kuondoka hapa'
        ],
        hint: 'Swali kuhusu utambulisho wa Yesu',
        funFact: '⛈️ Hata vitu vya asili vinamtambua Muumba na Bwana wao!'
      },
      hard: {
        question: 'Kusudi kuu la miujiza ya Yesu ni nini?',
        options: [
          'Kuwavutia umakini umati',
          'Kufunua Uungu Wake na kuonyesha upendo wa Mungu',
          'Kupata ushawishi',
          'Kusaidia kimwili tu'
        ],
        hint: 'Ni kuhusu ufunuo wa kimungu na huruma',
        funFact: '❤️ Kila muujiza unafunua moyo wa Mungu: upendo, huruma, nguvu!'
      }
    },

    36: {
      name: 'Ubadilishaji',
      challenge: 'Akabadilishwa mbele yao; uso Wake ukang\'aa kama jua...',
      easy: {
        question: 'Wanafunzi gani waliona Yesu akibadilishwa?',
        options: [
          'Wote kumi na wawili',
          'Petro, Yakobo na Yohana',
          'Petro na Yohana tu',
          'Wanawake waliomfuata'
        ],
        hint: 'Duara la ndani la watatu',
        funFact: '⛰️ Petro, Yakobo na Yohana: mashahidi wenye upendeleo wa utukufu wa kimungu!'
      },
      medium: {
        question: 'Ni wahusika gani wa Agano la Kale waliotokea?',
        options: [
          'Ibrahimu na Isaka',
          'Daudi na Sulemani',
          'Musa na Eliya',
          'Adamu na Nuhu'
        ],
        hint: 'Mwakilishi wa Sheria na wa Manabii',
        funFact: '📜 Musa (Sheria) na Eliya (Manabii) wanashuhudia kuhusu Yesu!'
      },
      hard: {
        question: 'Ubadilishaji huu unafunua nini kuhusu asili ya Yesu?',
        options: [
          'Ni nabii mkuu',
          'Uungu Wake uliofichwa unafunuliwa kwa muda',
          'Anadhibiti mwanga',
          'Anaweza kubadilisha mwonekano',
        ],
        hint: 'Ni kuhusu ufunuo wa asili Yake ya kimungu',
        funFact: '✨ Utukufu wa kimungu wa Yesu unang\'aa - utabiri wa ufufuo Wake!'
      }
    },

    37: {
      name: 'Kuingia kwa Ushindi',
      challenge: 'Hosana kwa Mwana wa Daudi! Amebarikiwa yeye ajaye kwa jina la Bwana!...',
      easy: {
        question: 'Yesu aliingia Yerusalemu akipanda mnyama gani?',
        options: ['Farasi', 'Punda', 'Ngamia', 'Kwa miguu'],
        hint: 'Mnyama ishara ya unyenyekevu na amani',
        funFact: '🐴 Punda inasimboliza Mfalme mnyenyekevu anayekuja kwa amani, si vita!'
      },
      medium: {
        question: 'Umati ulipiga kelele nini wakimpokea Yesu?',
        options: [
          'Mfalme aishi!',
          'Hosana! Amebarikiwa yeye ajaye kwa jina la Bwana!',
          'Utukufu kwa Mungu!',
          'Uhuru!'
        ],
        hint: 'Kilio cha furaha na baraka',
        funFact: '🌿 "Hosana" maana yake "okoa sasa" - wito kwa wokovu wa kimungu!'
      },
      hard: {
        question: 'Kwa nini kuingia huku ni "kwa ushindi" lakini kwa huzuni?',
        options: [
          'Kulikuwa na watu wachache',
          'Umati unaompokelea utamkataa baada ya siku 5',
          'Mamlaka hayakuwepo',
          'Kulikuwa na mvua'
        ],
        hint: 'Ni kuhusu kubadilika kwa moyo wa binadamu',
        funFact: '💔 Umati huo huo utapiga kelele "Msulubishe!" siku chache baadaye!'
      }
    },

    38: {
      name: 'Karamu ya Mwisho',
      challenge: 'Twaeni mle, huu ni mwili Wangu unaotolewa kwa ajili yenu...',
      easy: {
        question: 'Yesu alifanya nini kwa miguu ya wanafunzi Wake?',
        options: [
          'Aliwabariki',
          'Aliosha',
          'Aliipaka mafuta',
          'Alibusu'
        ],
        hint: 'Kitendo cha unyenyekevu na huduma',
        funFact: '🦶 Mwalimu anakuwa mtumishi - mapinduzi ya upendo na unyenyekevu!'
      },
      medium: {
        question: 'Yesu alianzisha nini katika karamu hii?',
        options: [
          'Ubatizo',
          'Ekaristi (Meza Takatifu)',
          'Maombi ya Bwana',
          'Kufunga'
        ],
        hint: 'Sakramenti yenye mkate na divai',
        funFact: '🍞🍷 Mkate na divai yanakuwa ishara za milele za dhabihu na upendo!'
      },
      hard: {
        question: 'Maana ya "Fanyeni hivi kwa ukumbusho Wangu" ni nini?',
        options: [
          'Rudieni karamu hii',
          'Sherehekeni kifo Changu na ufufuo hadi nirudi',
          'Kumbukeni maneno Yangu',
          'Pendaneni'
        ],
        hint: 'Ni kuhusu ukumbusho hai na wa unabii',
        funFact: '⏳ Kila Ekaristi inatangaza kifo cha Bwana mpaka atakapokuja!'
      }
    },

    39: {
      name: 'Gethsemane',
      challenge: 'Baba Yangu, ikiwa inawezekana, kikombe hiki kipite kwangu...',
      easy: {
        question: 'Yesu aliomba wapi kabla ya kukamatwa?',
        options: [
          'Hekaluni',
          'Bustanini mwa Gethsemane',
          'Mlima wa Mizeituni',
          'Nyumbani kwa marafiki'
        ],
        hint: 'Bustani ya miti ya mizeituni',
        funFact: '🫒 Gethsemane maana yake "shinikizo la mafuta" - mahali pa shinikizo kali!'
      },
      medium: {
        question: 'Wanafunzi walifanya nini Yesu alipoliomba?',
        options: [
          'Walimba pamoja Naye',
          'Walilala',
          'Walisimama ulinzi',
          'Waliondoka'
        ],
        hint: 'Hawakuweza kukesha hata saa moja',
        funFact: '😴 Roho iko tayari lakini mwili ni dhaifu - udhaifu wa kibinadamu!'
      },
      hard: {
        question: 'Uchungu wa Yesu unafunua nini kuhusu asili Yake?',
        options: [
          'Alikuwa mwanadamu tu',
          'Alikuwa mwanadamu kamili na Mungu kamili',
          'Alishuku jukumu Lake',
          'Alikuwa dhaifu'
        ],
        hint: 'Ni kuhusu siri ya Mwili',
        funFact: '✝️ Yesu anabeba kabisa uchungu wa kibinadamu huku akibaki mwaminifu kwa Mungu!'
      }
    }
  }
};

export default chapter3Translations;
